<template>
    <div class="my-interaction">
        <div ref="interactionTitle" class="titile">{{ $t('我的互动') }}</div>
        <!-- 我赞过的、我踩过的、我的评论 -->
        <div ref="interactionTabs" class="tabs">
            <div class="tabs-box" :class="tabs_type == 0 ? 'tabs-box-ok' : ''" @click="onTab(0)">
                {{ $t('我赞过的') }}
            </div>
            <div class="tabs-box" :class="tabs_type == 1 ? 'tabs-box-ok' : ''" @click="onTab(1)">
                {{ $t('我踩过的') }}
            </div>
            <div class="tabs-box" :class="tabs_type == 2 ? 'tabs-box-ok' : ''" @click="onTab(2)">
                {{ $t('我的评论') }}
            </div>
        </div>
        <!-- 我赞过的 -->
        <div ref="interactionContent" v-if="tabs_type == 0">
            <div class="list list-pc" ref="listContainer" @scroll="onPraiseHandleScroll"
                v-if="!isH5 && praise_list[0].length > 0">
                <div class="classify-list" v-for="(item, index) in praise_list" :key="index">
                    <template v-for="(e, i) in item">
                        <div class="list-box" :key="i" @click="onTopic(e.dynamics_id)" v-if="e.dynamics">
                            <div class="img-container">
                                <img :src="e.dynamics.thumb" alt="" class="img-container-img">
                            </div>
                            <div class="list-box-txt">
                                <div class="text-20 margin-bottom-8">{{ e.dynamics.title }}</div>
                                <div class="flex align-center">
                                    <div class="flex align-center margin-right-24">
                                        <img src="../../../../static/images/icon/icon39.png" alt=""
                                            class="list-box-txt-icon">
                                        <div>{{ e.dynamics.zan_num }}</div>
                                    </div>
                                    <div class="flex align-center">
                                        <img src="../../../../static/images/icon/icon40.png" alt=""
                                            class="list-box-txt-icon">
                                        <div>{{ e.dynamics.cai_num }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>

            <div class="h5-interaction-grid" v-if="isH5 && praiseFlatList.length > 0">
                <div class="h5-interaction-card" v-for="(e, i) in praiseFlatList" :key="'praise-' + i"
                    @click="onTopic(e.dynamics_id)" v-if="e.dynamics">
                    <div class="img-container">
                        <img :src="e.dynamics.thumb" alt="" class="img-container-img">
                    </div>
                    <div class="list-box-txt">
                        <div class="h5-card-title line2">{{ e.dynamics.title }}</div>
                        <div class="flex align-center h5-card-stats">
                            <div class="flex align-center margin-right-16">
                                <img src="../../../../static/images/icon/icon39.png" alt="" class="list-box-txt-icon">
                                <div>{{ e.dynamics.zan_num }}</div>
                            </div>
                            <div class="flex align-center">
                                <img src="../../../../static/images/icon/icon40.png" alt="" class="list-box-txt-icon">
                                <div>{{ e.dynamics.cai_num }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex flex-direction align-center empty-state" v-if="praise_list[0].length <= 0">
                <img src="../../../../static/images/my/zanwu.png" alt="" class="kong-img">
                <div class="text-18 text-999">{{ $t("暂无记录~") }}</div>
            </div>
        </div>
        <!-- 我踩过的 -->
        <div ref="interactionContent" class="amend" v-if="tabs_type == 1">
            <div class="list list-pc" ref="listContainer" @scroll="onTrampleHandleScroll"
                v-if="!isH5 && trample_list[0].length > 0">
                <div class="classify-list" v-for="(item, index) in trample_list" :key="index">
                    <template v-for="(e, i) in item">
                        <div class="list-box" :key="i" @click="onTopic(e.dynamics_id)" v-if="e.dynamics">
                            <div class="img-container">
                                <img :src="e.dynamics.thumb" alt="" class="img-container-img">
                            </div>
                            <div class="list-box-txt">
                                <div class="text-20 margin-bottom-8">{{ e.dynamics.title }}</div>
                                <div class="flex align-center">
                                    <div class="flex align-center margin-right-24">
                                        <img src="../../../../static/images/icon/icon38.png" alt=""
                                            class="list-box-txt-icon">
                                        <div>{{ e.dynamics.zan_num }}</div>
                                    </div>
                                    <div class="flex align-center">
                                        <img src="../../../../static/images/icon/icon51.png" alt=""
                                            class="list-box-txt-icon">
                                        <div>{{ e.dynamics.cai_num }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>

            <div class="h5-interaction-grid" v-if="isH5 && trampleFlatList.length > 0">
                <div class="h5-interaction-card" v-for="(e, i) in trampleFlatList" :key="'trample-' + i"
                    @click="onTopic(e.dynamics_id)" v-if="e.dynamics">
                    <div class="img-container">
                        <img :src="e.dynamics.thumb" alt="" class="img-container-img">
                    </div>
                    <div class="list-box-txt">
                        <div class="h5-card-title line2">{{ e.dynamics.title }}</div>
                        <div class="flex align-center h5-card-stats">
                            <div class="flex align-center margin-right-16">
                                <img src="../../../../static/images/icon/icon38.png" alt="" class="list-box-txt-icon">
                                <div>{{ e.dynamics.zan_num }}</div>
                            </div>
                            <div class="flex align-center">
                                <img src="../../../../static/images/icon/icon51.png" alt="" class="list-box-txt-icon">
                                <div>{{ e.dynamics.cai_num }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex flex-direction align-center empty-state" v-if="trample_list[0].length <= 0">
                <img src="../../../../static/images/my/zanwu.png" alt="" class="kong-img">
                <div class="text-18 text-999">{{ $t("暂无记录~") }}</div>
            </div>
        </div>
        <!-- 我的评论 -->
        <div ref="interactionContent" class="amend" v-if="tabs_type == 2">
            <div class="comment" v-if="evaluate_list.length > 0">
                <div class="comment-list" :class="{ 'comment-list-h5': isH5 }">
                    <div class="comment-list-box" v-for="(item, index) in evaluate_list" :key="index"
                        @click="onTopic(item.dynamics_id)">
                        <img :src="item.user_avatar" alt="">
                        <div class="comment-list-box-r">
                            <div class="comment-list-box-rt">
                                <div class="comment-list-box-rtl">{{ item.user_nickname }}</div>
                                <div class="comment-list-box-rtr">{{ $t("我") }}</div>
                            </div>
                            <div class="comment-list-box-rc">
                                {{ item.content }}
                            </div>
                            <div class="comment-list-box-rb">{{ item.create_time }}</div>
                        </div>
                    </div>
                </div>

                <div class="comment-pagination justify-center" :class="{ 'comment-pagination-h5': isH5 }">
                    <el-pagination layout="prev, pager, next" :page-size="page_size" :total="total" background
                        @current-change="onCurrentChange" :small="isH5"></el-pagination>
                </div>
            </div>

            <div class="flex flex-direction align-center empty-state" v-if="evaluate_list.length <= 0">
                <img src="../../../../static/images/my/zanwu.png" alt="" class="kong-img">
                <div class="text-18 text-999">{{ $t("暂无记录~") }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { praiseRecord, trampleRecord, myComment } from '@/api/user';

    export default {
        name: "interaction",
        data() {
            return {
                tabs_type: 0,//标签索引

                praise_list: [[], []], // 赞列表
                praise_page: 1, // 赞分页
                praise_lastScrollLeft: 0, // 赞记录上次滚动位置
                praise_loading: false,
                praise_noMore: false,

                trample_list: [[], []], // 踩列表
                trample_page: 1, // 踩分页
                trample_lastScrollLeft: 0, // 踩记录上次滚动位置
                trample_loading: false,
                trample_noMore: false,

                evaluate_list: [],//评价列表
                page_size: 0,//单页数量
                total: 0,//订单总数
                page: 1,//页数
                isH5: typeof window !== 'undefined' && window.innerWidth < 768,
                // 互动页面入场动画实例，用于组件销毁时释放动画资源
                interactionEntranceAnimation: null,
            };
        },
        computed: {
            praiseFlatList() {
                return [...this.praise_list[0], ...this.praise_list[1]];
            },
            trampleFlatList() {
                return [...this.trample_list[0], ...this.trample_list[1]];
            },
        },
        mounted() {
            this.onPraise();
            this.onMyComment();
            this.updateIsH5();
            window.addEventListener('resize', this.updateIsH5);
            window.addEventListener('scroll', this.onH5WindowScroll, { passive: true });
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateIsH5);
            window.removeEventListener('scroll', this.onH5WindowScroll);
            if (this.interactionEntranceAnimation) {
                this.interactionEntranceAnimation.progress(1).kill();
            }
        },
        methods: {
            /** 播放互动页面当前内容区的入场动效 */
            playInteractionEntranceAnimation() {
                if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                    return;
                }
                if (this.interactionEntranceAnimation) {
                    this.interactionEntranceAnimation.progress(1).kill();
                }
                const targets = [
                    this.$refs.interactionTitle,
                    this.$refs.interactionTabs,
                    this.$refs.interactionContent,
                ].filter(Boolean);
                this.interactionEntranceAnimation = this.$gsap.fromTo(targets, {
                    y: 16,
                    opacity: 0,
                }, {
                    y: 0,
                    opacity: 1,
                    duration: 0.45,
                    stagger: 0.08,
                    ease: 'power2.out',
                    onComplete: () => {
                        this.$gsap.set(targets, { clearProps: 'opacity,transform' });
                    },
                });
            },
            updateIsH5() {
                this.isH5 = window.innerWidth < 768;
            },
            onH5WindowScroll() {
                if (!this.isH5) return;
                const reachedBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 120;
                if (!reachedBottom) return;
                if (this.tabs_type === 0) {
                    this.onPraise();
                } else if (this.tabs_type === 1) {
                    this.onTrample();
                }
            },
            /** 专题详情 */
            onTopic(id) {
                this.$router.push({ name: 'TopicDetalis', params: { id } });
            },
            onCurrentChange(e) {
                this.page = e
                this.onMyComment()
            },
            /**我的评论 */
            onMyComment() {
                let data = {
                    page: this.page
                }
                myComment(data).then(res => {
                    this.page_size = res.data.per_page
                    this.total = res.data.total
                    this.evaluate_list = res.data.data || []
                    this.$nextTick(() => {
                        this.playInteractionEntranceAnimation();
                    });
                })
            },
            /**tab点击 */
            onTab(e) {
                this.tabs_type = e;
                if (e == 0) {
                    if (!this.praise_list[0].length && !this.praise_list[1].length && !this.praise_noMore) {
                        this.onPraise();
                    }
                } else if (e == 1) {
                    if (!this.trample_list[0].length && !this.trample_list[1].length && !this.trample_noMore) {
                        this.onTrample();
                    }
                }
                this.$nextTick(() => {
                    this.playInteractionEntranceAnimation();
                });
            },
            /** 踩处理滚动事件 */
            onTrampleHandleScroll(event) {
                const container = event.target;
                const { scrollLeft, scrollWidth, clientWidth } = container;

                // 检测是否向右滚动并且接近最右边
                if (scrollLeft > this.trample_lastScrollLeft &&
                    scrollLeft + clientWidth >= scrollWidth - 100) {
                    this.onTrample();
                }

                this.trample_lastScrollLeft = scrollLeft;
            },
            /** 踩列表 */
            async onTrample() {
                if (this.trample_loading || this.trample_noMore) return;

                this.trample_loading = true;
                try {
                    const res = await trampleRecord({ page: this.trample_page });
                    const list = (res.data && res.data.data) || [];

                    if (list.length === 0) {
                        this.trample_noMore = true;
                        return;
                    }

                    // 分割数组
                    const firstPart = [];
                    const secondPart = [];

                    list.forEach((e, i) => {
                        if (i % 2) {
                            secondPart.push(e)
                        } else {
                            firstPart.push(e)
                        }
                    })

                    firstPart.forEach(element => {
                        this.trample_list[0].push(element);
                    });
                    secondPart.forEach(element => {
                        this.trample_list[1].push(element);
                    });

                    this.trample_page++;
                    this.$nextTick(() => {
                        this.playInteractionEntranceAnimation();
                    });
                } catch (error) {
                    console.error('加载动态列表失败：', error);
                } finally {
                    this.trample_loading = false;
                }
            },

            /** 赞处理滚动事件 */
            onPraiseHandleScroll(event) {
                const container = event.target;
                const { scrollLeft, scrollWidth, clientWidth } = container;

                // 检测是否向右滚动并且接近最右边
                if (scrollLeft > this.praise_lastScrollLeft &&
                    scrollLeft + clientWidth >= scrollWidth - 100) {
                    this.onPraise();
                }

                this.praise_lastScrollLeft = scrollLeft;
            },
            /** 赞列表 */
            async onPraise() {
                if (this.praise_loading || this.praise_noMore) return;

                this.praise_loading = true;
                try {
                    const res = await praiseRecord({ page: this.praise_page });
                    const list = (res.data && res.data.data) || [];

                    if (list.length === 0) {
                        this.praise_noMore = true;
                        return;
                    }

                    // 分割数组
                    const firstPart = [];
                    const secondPart = [];

                    list.forEach((e, i) => {
                        if (i % 2) {
                            secondPart.push(e)
                        } else {
                            firstPart.push(e)
                        }
                    })

                    firstPart.forEach(element => {
                        this.praise_list[0].push(element);
                    });
                    secondPart.forEach(element => {
                        this.praise_list[1].push(element);
                    });

                    this.praise_page++;
                    this.$nextTick(() => {
                        this.playInteractionEntranceAnimation();
                    });
                } catch (error) {
                    console.error('加载动态列表失败：', error);
                } finally {
                    this.praise_loading = false;
                }
            },
        },
    };
</script>

<style scoped lang="scss">
    .my-interaction {
        box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);
        margin: 16px 12px 0;
        border-radius: 8px;
        padding: 24px 24px 90px;
        box-sizing: border-box;
    }

    .titile {
        padding: 0 0 24px;
        font-size: 18px;
        font-weight: bold;
        border-bottom: 1px solid #EAEBEF;
    }

    /**标签 */
    .tabs {
        display: flex;
        align-items: center;
        margin-top: 24px;
        font-size: 14px;
        margin-bottom: 24px;

        .tabs-box {
            margin-right: 64px;
            cursor: pointer;
            padding-bottom: 11px;
        }

        .tabs-box-ok {
            color: #000;
            padding-bottom: 8px;
            border-bottom: 3px solid #000;
        }
    }

    .list {
        width: 100%;
        overflow: auto;
        scroll-behavior: smooth;
        padding-bottom: 22px;

        /* // 新增滚动条样式 */
        &::-webkit-scrollbar {
            /* 滚动条高度（横向滚动条的高度） */
            height: 8px;
        }

        /* // 滚动条轨道 */
        &::-webkit-scrollbar-track {
            /* 轨道背景色 */
            background: #D9D9D9;
            /* 轨道圆角（与高度匹配，使轨道呈圆角矩形） */
            border-radius: 4px;
        }

        /* // 滚动条滑块（实际可拖动的部分） */
        &::-webkit-scrollbar-thumb {
            /* 滑块宽度（即滚动条的长度） */
            width: 60px;
            /* 滑块颜色 */
            background: #000000;
            /* 滑块圆角 */
            border-radius: 4px;
        }

        /* // 滑块hover状态 */
        &::-webkit-scrollbar-thumb:hover {
            /* hover时的颜色 */
            background: #000000;
        }

        .classify-list {
            /* // padding: 0 162px; */
            display: flex;
            flex-wrap: wrap;
            gap: 24px;
            width: max-content;
            margin-bottom: 24px;

            .list-box {
                /* // width: 480px; */
                /* // height: 240px; */
                width: 372px;
                height: 268px;
                border-radius: 8px;
                overflow: hidden;
                position: relative;
                cursor: pointer;

                .img-container {
                    width: 100%;
                    height: 100%;
                    overflow: hidden;

                    .img-container-img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transition: transform 0.5s ease;
                    }
                }

                &:hover {
                    .img-container-img {
                        transform: scale(1.2);
                    }
                }

                .list-box-txt {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    color: #FFFFFF;
                    padding: 20px;
                    text-align: left;
                    background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
                    width: 100%;
                    z-index: 1;
                    box-sizing: border-box;

                    /* 确保文字在放大图片上方 */
                    .list-box-txt-box {
                        display: flex;
                        align-items: end;

                        .list-box-txt-box-l {
                            width: 200px;
                        }
                    }

                    .list-box-txt-icon {
                        width: 20px;
                        height: 20px;
                        margin-right: 6px;
                    }
                }
            }
        }

        .classify-list:last-child {
            margin-bottom: 0;
        }

        .loading,
        .no-more {
            padding: 20px;
            text-align: center;
            color: #666;
        }
    }

    .kong-img {
        width: 130px;
    }

    .comment-pagination {
        padding-top: 32px;
    }

    .h5-interaction-grid {
        display: none;
    }

    .comment {

        .comment-tit {
            font-size: 20px;
            padding-bottom: 24px;
        }

        .comment-textarea {
            width: 100%;
            height: 100px;
            background: #F8F8F8;
            border-radius: 8px;
            display: flex;
            align-items: end;
            /* // justify-content: space-between; */

            textarea {
                width: calc(100% - 84px);
                height: 100px;
                background: #F8F8F8;
                padding: 16px;
                font-size: 16px;
                resize: none;
            }

            div {
                width: 72px;
                height: 32px;
                background: #000000;
                border-radius: 8px 8px 8px 8px;
                line-height: 32px;
                color: #FFFFFF;
                font-size: 14px;
                text-align: center;
                margin-bottom: 12px;
                cursor: pointer;
            }
        }

        .comment-list {
            height: calc(100vh - 440px);
            overflow: auto;
            /* // padding-top: 8px; */

            /* // 新增滚动条样式 */
            &::-webkit-scrollbar {
                /* // height: 8px; // 滚动条高度（横向滚动条的高度） */
                width: 8px;
            }

            /* // 滚动条轨道 */
            &::-webkit-scrollbar-track {
                /* 轨道背景色 */
                background: #D9D9D9;
                /* 轨道圆角（与高度匹配，使轨道呈圆角矩形） */
                border-radius: 4px;
            }

            /* // 滚动条滑块（实际可拖动的部分） */
            &::-webkit-scrollbar-thumb {
                /* 滑块宽度（即滚动条的长度） */
                width: 60px;
                /* 滑块颜色 */
                background: #000000;
                /* 滑块圆角 */
                border-radius: 4px;
            }

            /* // 滑块hover状态 */
            &::-webkit-scrollbar-thumb:hover {
                /* hover时的颜色 */
                background: #000000;
            }


            .comment-list-box {
                padding: 20px 0;
                border-bottom: 1px solid #CCCCCC;
                display: flex;
                cursor: pointer;

                img {
                    width: 36px;
                    height: 36px;
                    border-radius: 50px;
                }

                .comment-list-box-r {
                    padding-left: 16px;

                    .comment-list-box-rt {
                        display: flex;
                        align-items: center;

                        .comment-list-box-rtl {
                            font-size: 14px;
                            color: #000000;
                            font-weight: 500;
                        }

                        .comment-list-box-rtr {
                            color: #FFFFFF;
                            font-size: 12px;
                            padding: 2px 4px;
                            background: #000000;
                            border-radius: 4px;
                            margin-left: 8px;
                        }
                    }

                    .comment-list-box-rc {
                        margin: 8px 0;
                        font-size: 14px;
                        color: #666666;
                    }

                    .comment-list-box-rb {
                        font-size: 14px;
                        color: #999999;
                    }
                }
            }

            .comment-list-box:last-child {
                border-bottom: none;
            }
        }
    }

    @media (max-width: 767px) {
        .my-interaction {
            width: 100%;
            margin: 0;
            padding: 16px 12px 24px;
            box-sizing: border-box;
            box-shadow: none;
            border-radius: 0;
            background: transparent;
        }

        .titile {
            padding: 0 0 16px;
            font-size: 16px;
        }

        .tabs {
            width: 100%;
            margin-top: 16px;
            margin-bottom: 16px;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
            -ms-overflow-style: none;

            &::-webkit-scrollbar {
                display: none;
            }

            .tabs-box {
                flex: 1;
                flex-shrink: 0;
                min-width: 0;
                margin-right: 0;
                text-align: center;
                font-size: 13px;
                white-space: nowrap;
                padding-bottom: 10px;
            }

            .tabs-box-ok {
                padding-bottom: 7px;
            }
        }

        .h5-interaction-grid {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 10px;
            width: 100%;
        }

        .h5-interaction-card {
            border-radius: 8px;
            overflow: hidden;
            position: relative;
            aspect-ratio: 3 / 4;
            background: #f0f0f0;
            cursor: pointer;

            .img-container {
                width: 100%;
                height: 100%;

                .img-container-img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .list-box-txt {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                color: #fff;
                padding: 10px 8px;
                background: linear-gradient(transparent, rgba(0, 0, 0, 0.75));
                box-sizing: border-box;

                .h5-card-title {
                    font-size: 13px;
                    line-height: 1.4;
                    margin-bottom: 6px;
                }

                .h5-card-stats {
                    font-size: 12px;
                }

                .list-box-txt-icon {
                    width: 16px;
                    height: 16px;
                    margin-right: 4px;
                }
            }
        }

        .empty-state {
            padding: 48px 0;
            background: #fff;
            border-radius: 8px;

            .text-18 {
                font-size: 14px;
            }
        }

        .comment {
            .comment-list-h5 {
                height: auto;
                max-height: none;
                overflow: visible;
                background: #fff;
                border-radius: 8px;
                padding: 0 12px;
                box-sizing: border-box;

                .comment-list-box {
                    padding: 14px 0;

                    img {
                        width: 40px;
                        height: 40px;
                        flex-shrink: 0;
                    }

                    .comment-list-box-r {
                        flex: 1;
                        min-width: 0;
                        padding-left: 12px;
                    }

                    .comment-list-box-rc {
                        word-break: break-all;
                        line-height: 1.5;
                    }
                }
            }

            .comment-pagination-h5 {
                padding-top: 16px;
                overflow-x: auto;
                -webkit-overflow-scrolling: touch;
                display: flex;
                justify-content: center;
                width: 100%;

                /deep/ .el-pagination {
                    margin: 0 auto;
                    justify-content: center;
                }
            }
        }    }
</style>



// WEBPACK FOOTER //
// src/view/my/components/interaction.vue